import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Inject, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-dataset-card',
  templateUrl: './dataset-card.component.html',
  styleUrls: ['./dataset-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasetCardComponent {

  @HostBinding('style.background') _backgroundColor = 'unset';

  @Input() backgroundColor = '';
  @Input() hoverBackgroundColor = '';

  @Input() selected = false;

  @HostListener('mouseenter') onEnter() {
    if (!this.selected) {
      this._backgroundColor = this.hoverBackgroundColor;
    }
  }

  @HostListener('mouseleave') onLeave() {
    if (this.selected) {
      this._backgroundColor = this.backgroundColor;
    }
    else {
      this._backgroundColor = 'unset';
    }
  }

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnChanges(sp: SimpleChanges) {
    if (sp.selected && this.selected) {
      this._backgroundColor = this.backgroundColor;
    }
    else {
      this._backgroundColor = 'unset';
    }
  }

  @HostListener('click') click() {
    const elements = this.document.getElementsByTagName('app-page-content');
    if (elements.item(0)) {
      elements.item(0).scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

}
